module.exports = __webpack_public_path__ + "static/media/clue0103.6bb8add2.jpg";